import { render, staticRenderFns } from "./gifts.vue?vue&type=template&id=73186063&scoped=true&"
import script from "./gifts.vue?vue&type=script&lang=js&"
export * from "./gifts.vue?vue&type=script&lang=js&"
import style0 from "./gifts.vue?vue&type=style&index=0&id=73186063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73186063",
  null
  
)

export default component.exports